import classnames from "classnames";
import * as React from "react";

export interface TabHeaderProps {
  isDisabled?: boolean;
  children?: any;
  icon?: string;
  isActive?: boolean;
  isVisible?: boolean;
  label?: string;
  onClick?: () => void;
}

export default ({ children, isActive, isDisabled, isVisible, icon, label, onClick }: TabHeaderProps) => (
  <li
    className={classnames("tab-header", {
      active: isActive,
      disabled: isDisabled,
      none: typeof isVisible === "boolean" && !isVisible
    })}
    onClick={(e) => {
      e.preventDefault();
      onClick && onClick();
    }}
  >
    <a href="#">
      {!!icon && <i className={icon}></i>}
      {label}

      {children}
    </a>
  </li>
);
